import SendInvoiceModal from './SendInvoiceModal.component'

export default SendInvoiceModal
